import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { ShellRoutes } from '../portal-routes';
import { PortalSessionMarker } from './portal-session-marker';

/**
 * Okta sign-in callback, the start of the portal session. The marker is written before the tokens are stored:
 * stored tokens are validated against it right away and would otherwise be discarded as orphaned.
 */
@Component({
  standalone: true,
  template: ''
})
export class LoginCallbackComponent implements OnInit {
  private readonly oktaAuth = inject(OKTA_AUTH);
  private readonly router = inject(Router);

  async ngOnInit(): Promise<void> {
    try {
      const { tokens } = await this.oktaAuth.token.parseFromUrl();
      const userId = tokens.idToken?.claims.sub;
      if (!userId) {
        throw new Error('Okta returned no id token');
      }
      PortalSessionMarker.write(userId);
      // Stores the tokens and restores the original URI (the landing route)
      await this.oktaAuth.handleLoginRedirect(tokens);
    } catch {
      // Stale or broken callback (e.g. reloaded): the user can simply sign in again
      await this.router.navigateByUrl(ShellRoutes.welcome);
    }
  }
}
